import * as React from "react";

export interface EmptyStateProps {
  hasCategories: boolean;
  searchQuery: string;
}

const emptyStateStyle: React.CSSProperties = {
  padding: "12px",
  textAlign: "center",
  color: "#999",
  fontSize: "12px",
  fontWeight: "600",
};

const emptyStateNoCategoriesStyle: React.CSSProperties = {
  ...emptyStateStyle,
  padding: "20px",
  fontWeight: "400",
};

const EmptyState: React.FC<EmptyStateProps> = ({ hasCategories, searchQuery }) => {
  if (!hasCategories) {
    return <div style={emptyStateNoCategoriesStyle}>No categories available</div>;
  }
  return <div style={emptyStateStyle}>No categories found matching "{searchQuery}"</div>;
};

export default EmptyState;
